import { useMemo } from 'react'
import { isArr } from 'lib/util'
import { useMemoRef } from 'platform/react/hook'
import Icon from 'ui/Element/Icon'

/**
 * StatusIcon UI element
 *
 * Simple element used to display an icon for a specific status with the correct color.
 *
 *
 * @param {React.Ref} forwardedRef      ref to the element
 * @param {Object} events               an object containing an onOpen event handler
 * @param {Function} events.onOpen      a function that returns the status to be displayed by
 *                                      passing it its key
 * @param {String} value                a string to be used as value
 * @returns {JSX.Element}               the new Text element
 */
const Status = ({ forwardedRef, events, value }) => {
  const [currentStatus = {}] = useMemo(() => (
    value && isArr(value) ? value : events?.onOpen?.(value) || [{}]
  ), [value, events])

  return !currentStatus?.value ? null : (
    <Icon
      source={currentStatus?.icon || 'dot'}
      color={currentStatus?.color}
    />
  )
}

export default useMemoRef(Status, props => [
  props.value,
  props.events,
])
